<template>
    <div>
        <vs-card>
            <!-- dropzone -->
            <input type="file" id="files" ref="files" name="files"
                   :accept="$route.name === 'Règlement' || $route.name === 'Clients' ? '.xlsx' : '.pdf,.xml'"
                   :multiple="!($route.name === 'Règlement' || $route.name === 'Clients')"
                   @change="handleClick($event)"/>
            <div
                @click="$refs.files.click()"
                @drop="handleDrop"
                @dragover="handleDragover"
                @dragenter="handleDragover"
                v-if="!files || !files.length"
                class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">

                <div class="text-center py-20">
                    <div class="deposit mb-8 mx-auto">
                        <div class="text-primary font-medium h5">GLISSEZ / DÉPOSEZ <br>
                            VOS DOCUMENTS
                        </div>
                    </div>
                    <vs-button type="border" @click.stop="$refs.files.click()">Parcourir...</vs-button>
                </div>
            </div>
            <!-- ./dropzone -->
            <!-- fileList -->
            <div v-else class="px-8 py-8">

                <vs-alert title="Erreur" active="true" color="danger" class="mb-8" style="height: unset;"
                          v-if="errorMessage">
                    Erreur lors de l'envoi de vos fichiers, veuillez cliquer sur "Annuler" et recommencez l'opération
                </vs-alert>
                <vs-alert title="Succès" active="true" color="success" class="mb-8" style="height: unset;"
                          v-else-if="successMessage">
                    Vos fichiers ont bien été envoyés. Fermeture de la fenêtre automatique dans quelques secondes ou
                    cliquez sur "Annuler"
                </vs-alert>
                <vs-alert active="true" class="mb-8" style="height: unset;" v-else>
                    Voici la liste des fichiers que vous êtes sur le point d'envoyer sur nos serveurs :<br><strong>Cliquer
                    sur <span class="text-success">"valider"</span> pour finaliser l'opération.</strong>
                </vs-alert>

                <vs-table class="text-left" stripe max-items="10"
                          :pagination="!($route.name === 'Règlement' || $route.name === 'Clients' || files.length < 11)"
                          :data="files">
                    <template slot="thead">
                        <vs-th style="width:20px">&nbsp;</vs-th>
                        <vs-th>Nom du fichier</vs-th>
                        <vs-th>Poids</vs-th>
                        <vs-th>type</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="index" v-for="(file, index) in data">
                            <vs-td>
                                <feather-icon icon="FileIcon" svgClasses="h-6 w-6 stroke-current text-success"/>
                            </vs-td>

                            <vs-td :data="file.email">
                                {{ file.name }}
                            </vs-td>

                            <vs-td :data="file.size">
                                {{ (file.size / 1000.0).toFixed(1) }} Ko
                            </vs-td>

                            <vs-td :data="file.name">
                                {{ file.name.match(/\.[0-9a-z]+$/i)[0] }}
                            </vs-td>

                        </vs-tr>
                    </template>

                </vs-table>
                <div v-if="$route.name === 'Zone de dépôt'" class="vx-row mb-2 justify-center">
                    <div class="vx-col sm:w-1/2 w-full h-32 mb-2">
                        <vs-textarea
                            label="Commentaire"
                            class="w-full mt-5"
                            v-model="commentaire"
                            placeholder="Ajoutez un commentaire ici..."/>
                    </div>
                </div>
                <div v-show="showProgress" class="progress">
                    <p>Chargement des fichiers en cours...</p>
                    <div class="progress_bar">
                        <div class="progress_bar-update" ref="progress_bar"></div>
                    </div>
                    <span>{{ progress }} %</span>
                </div>
                <div v-if="progress === 100">
                    <p class="text-center">Veuillez patienter...</p>
                </div>
                <div class="flex justify-center mx-auto mt-8">
                    <vs-button class="mx-2" type="border" color="primary" :disabled="files.length === 0"
                               @click.native="clearFiles()">Annuler
                    </vs-button>
                    <vs-button v-if="$route.name === 'Règlement'" class="mx-2" type="gradient" color="success"
                               icon-pack="feather" icon="icon-save" :disabled="files.length === 0 || disableButton"
                               @click.native="uploadXLSFiles()">Valider
                    </vs-button>
                    <vs-button v-else-if="$route.name === 'Clients'" class="mx-2" type="gradient" color="success"
                               icon-pack="feather" icon="icon-save" :disabled="files.length === 0 || disableButton"
                               @click.native="uploadClientXLSFiles()">Valider
                    </vs-button>
                    <vs-button v-else class="mx-2" type="gradient" color="success" icon-pack="feather" icon="icon-save"
                               :disabled="files.length === 0 || disableButton" @click.native="uploadFiles()">Valider
                    </vs-button>
                </div>


            </div>
            <!-- ./fileList -->
        </vs-card>
    </div>
</template>

<script>
import axios from '@/axios.js'
import UploadFilesService from '@/services/UploadFilesService'

export default {
    name: 'upload-files',
    props: {
        onSuccess: {
            type: Function,
            default: () => {
            }
        }
    },
    data() {
        return {
            files: [],
            commentaire: '',
            uploadDone: false,
            progress: 0,
            disableButton: false,
            showProgress: false,
            successMessage: false,
            errorMessage: false
        }
    },

    methods: {
        handleDragover(e) {
            e.stopPropagation()
            e.preventDefault()
            e.dataTransfer.dropEffect = 'copy'
        },
        handleDrop(e) {
            e.stopPropagation()
            e.preventDefault()
            const files = e.dataTransfer.files
            //check file format for each file here
            for (const file of files) {
                if (!this.isAcceptedFormat(file)) {
                    this.$vs.notify({
                        title: 'Format invalide',
                        text: 'Seuls les fichiers .pdf sont acceptés',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                    return false
                }
            }
            this.files = files
        },
        handleClick() {
            this.files = this.$refs.files.files
        },

        isAcceptedFormat(file) {
            return /\.(xlsx|xls|csv|jpg|jpeg|png|pdf|doc|docx|xml)$/.test(file.name)
        },

        clearFiles() {
            this.$refs.files.value = null
            this.$refs.files.files = null
            this.files = []
            this.errorMessage = false
            this.successMessage = false
            this.disableButton = false
            this.showProgress = false
        },

        uploadFiles() {
            UploadFilesService.upload({files: this.files, commentaire: this.commentaire}, event => {
                this.disableButton = true
                this.showProgress = true
                this.progress = Math.round((100 * event.loaded) / event.total)
                this.$refs.progress_bar.style.width = `${this.progress}%`
            })
                .then(res => {
                    this.commentaire = ''
                    this.successMessage = true
                    this.$vs.notify({
                        title: 'Envoi effectué',
                        text: res.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'
                    })

                    this.uploadDone = true
                    setTimeout(() => {
                        this.$refs['files'].value = null
                        this.uploadDone = false
                        this.showProgress = false
                        this.successMessage = false
                        this.disableButton = false
                        this.clearFiles()
                    }, 8000)
                    this.$emit('uploadDone', UploadFilesService.getFiles())
                })
                .catch(() => {
                    this.uploadDone = false
                    this.showProgress = false
                    this.errorMessage = true
                    this.$vs.notify({
                        title: 'Envoi échoué',
                        text: 'Désolé, l’envoi des fichiers a échoué !',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
        },

        uploadXLSFiles() {
            const formData = new FormData()
            const filesXLS = this.$refs.files.files[0]

            formData.append('file', filesXLS)
            formData.append('client_id', this.$store.state.user.activeUser.client_id)

            axios.post('/bills/import',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: event => {
                        this.disableButton = true
                        this.showProgress = true
                        this.progress = Math.round((100 * event.loaded) / event.total)
                        // console.log(document.querySelector(""))
                        this.$refs.progress_bar.style.width = `${this.progress}%`
                    }
                }
            )
                .then(response => {
                    console.log(response)
                    this.successMessage = true
                    this.$vs.notify({
                        title: 'Envoi effectué',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'
                    })

                    this.uploadDone = true
                    setTimeout(() => {
                        this.$refs['files'].value = null
                        this.uploadDone = false
                        this.showProgress = false
                        this.successMessage = false
                        this.disableButton = false
                        this.clearFiles()
                    }, 8000)
                    this.$emit('uploadDone', UploadFilesService.getFiles())
                })
                .catch(e => {
                    this.$store.dispatch('displayError', {message: 'Erreur de chargement des factures', error:e}, {root: true})
                })
        },
        uploadClientXLSFiles() {
            const formData = new FormData()
            const filesXLS = this.$refs.files.files[0]

            formData.append('file', filesXLS)

            axios.post('/debiteurs/import',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: event => {
                        this.disableButton = true
                        this.showProgress = true
                        this.progress = Math.round((100 * event.loaded) / event.total)
                        // console.log(document.querySelector(""))
                        this.$refs.progress_bar.style.width = `${this.progress}%`

                    }
                }
            )
                .then(response => {
                    console.log(response)
                    this.successMessage = true
                    this.$vs.notify({
                        title: 'Envoi effectué',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'
                    })

                    this.uploadDone = true
                    setTimeout(() => {
                        this.$refs['files'].value = null
                        this.uploadDone = false
                        this.showProgress = false
                        this.successMessage = false
                        this.disableButton = false
                        this.clearFiles()
                    }, 8000)
                    this.$emit('uploadDone', UploadFilesService.getFiles())
                })
                .catch(e => {
                    this.uploadDone = false
                    this.showProgress = false
                    this.errorMessage = true
                    this.$store.dispatch('displayError', {message: 'Erreur de chargement des factures', error:e}, {root: true})
                })
        }
    }
}
</script>

<style lang="scss" scoped>
input[type="file"] {
    position: absolute;
    top: -500px;
}

.deposit {
    background: url('~@/assets/images/icons/circle-bill-icon.svg') no-repeat center center;
    width: 230px;
    height: 230px;
    background-size: contain;
    padding: 104px 0 0;
}

div.file-listing {
    width: 200px;
}

span.remove-file {
    color: red;
    cursor: pointer;
    float: right;
}
</style>
